import "./sign-in.css";
import { render } from "solid-js/web";
import { SignInApp } from "./SignInApp";

declare const pageVars: {
	authServices: Array<{ id: string; label: string; icon?: string }>;
	emailSignInEnabled: boolean;
	stateID?: string;
	signupCode: string | null;
};

document.addEventListener("DOMContentLoaded", () => {
	const parameters = new URLSearchParams(window.location.search);
	const client = parameters.get("client");
	const presentation =
		client === "ios" || client === "android" ? "app-embedded" : "full";
	const serviceName = window.location.hostname.includes("askgvt") ? "AskGVT" : "GVTLabs";

	document.body.classList.add(presentation);
	document.body.dataset.serviceName = serviceName;

	render(
		() => (
			<SignInApp
				serviceName={serviceName}
				authServices={pageVars.authServices}
				emailSignInEnabled={pageVars.emailSignInEnabled}
				stateID={pageVars.stateID}
				signupCode={pageVars.signupCode}
				presentation={presentation}
			/>
		),
		document.body,
	);
});
